export default __webpack_public_path__ + "static/media/mascot-into-the-wild.8164952c.gif";